const SCROLLBAR_SIZE = 12;
const PAGE_LABEL_SPACE = 36;

// Border-box dimensions do not change when content creates a scrollbar.
// Reserve its space even before it appears, preventing fit/scrollbar feedback.
export function viewerArea(element, style) {
  const value = key => parseFloat(style[key]) || 0;
  const scrollbar = parseFloat(style.getPropertyValue?.('--studio-scrollbar-size')) || SCROLLBAR_SIZE;
  return {
    width: Math.max(1, Math.floor(element.offsetWidth - value('borderLeftWidth') - value('borderRightWidth') - value('paddingLeft') - value('paddingRight') - scrollbar * 2)),
    height: Math.max(1, Math.floor(element.offsetHeight - value('borderTopWidth') - value('borderBottomWidth') - value('paddingTop') - value('paddingBottom') - PAGE_LABEL_SPACE - scrollbar)),
  };
}

// Keep CSS zoom independent of backing-buffer resolution and browser limits.
export function canvasPixelRatio(width, height, nativeRatio = 1) {
  if (![width, height, nativeRatio].every(number => Number.isFinite(number) && number > 0)) return 1;
  return Math.min(nativeRatio, 2, Math.sqrt(12_000_000 / (width * height)), 8192 / Math.max(width, height));
}
